module.exports = __webpack_public_path__ + "static/media/26UNRWA7.b21f4264.jpg";